import { Component, h, Prop, State } from '@stencil/core';

@Component({
  tag: 'qw-basket-summary-responsive',
  styleUrl: 'qw-basket-summary-responsive.scss',
  shadow: false,
})
export class QwBasketResponsive {
  @State() isMobile: boolean;
  @Prop() qwTitle: string = 'Your Booking';
  @Prop() qwLocation: string = JSON.stringify(Location);
  @Prop() qwLang: string = 'en';
  @Prop() qwBasketHasCustomTaxes: string;

  componentWillLoad() {
    this.checkViewport();
  }

  checkViewport() {
    this.isMobile = window.matchMedia('(max-width: 768px)').matches;
  }

  render() {
    return this.isMobile ? (
      <qw-basket-summary-mobile
        qw-basket-summary-title={this.qwTitle}
        qw-basket-summary-locations={this.qwLocation}
        current-lang={this.qwLang}
        qw-basket-has-custom-taxes={this.qwBasketHasCustomTaxes}
      ></qw-basket-summary-mobile>
    ) : (
      <qw-basket-summary
        qw-basket-summary-title={this.qwTitle}
        qw-basket-summary-locations={this.qwLocation}
        current-lang={this.qwLang}
        qw-basket-has-custom-taxes={this.qwBasketHasCustomTaxes}
      ></qw-basket-summary>
    );
  }
}
